const mutations = {
    setPredDate: (state, pred_date) => {
        state.pred_date = pred_date
    },
    setStoreId: (state, store_id) => {
        state.store_id = store_id
    },
    setGraphSetting: (state, graph_setting) => {
        state.graph_setting = graph_setting
    }
};

export default mutations;